import messages from './questionnaireSourceMessages.json';
import type {CalcLabel} from '@/uptk/core/components/moduleEntity/calc/calcModel';
/** Authored source translations keyed by exact source text; unfamiliar text remains visibly untranslated. */
export function questionnaireSourceLabel(fr:string):CalcLabel{return (messages as Record<string,CalcLabel>)[fr]??{fr};}
